import moment from "moment";
import { createCrudActions } from '../utils/crudGenerator';
import { MAINTENANCE_STATUS } from "../constants/utils";

const formatMaintenances = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: item.name || `${item.date ? moment(item.date).format("DD/MM/YYYY") : "Mantenimiento"} (${MAINTENANCE_STATUS.find(status => status.value === item.status)?.label || "PENDING"})`,
        value: item._id,
        date: item.date && moment(item.date),
        completedAt: item.completedAt ? moment(item.completedAt) : null,
        createdAt: item.createdAt ? moment(item.createdAt) : null,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchMaintenances,
    create: createMaintenance,
    update: updateMaintenance,
    delete: deleteMaintenances
} = createCrudActions('MAINTENANCE', "Mantenimiento", formatMaintenances);
